import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
// Import MUI's Container from @mui/material (instead of using styled.div)
import { Container } from "@mui/material";
import styled from "styled-components";

const basicSchema = Yup.object().shape({
  typeName: Yup.string().required("Message is required"),
});

const BroadcastMessage = ({ socket }) => {
  const history = useNavigate();

  const onSubmit = async (values, actions) => {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    sendBroadcastMessage(values);
  };

  const { values, errors, touched, isSubmitting, handleBlur, handleChange, handleSubmit, submitForm } =
    useFormik({
      initialValues: {
        typeName: "",
      },
      validationSchema: basicSchema,
      onSubmit,
    });

  const notifySuccess = () =>
    toast.success("Broadcast message sent", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const sendBroadcastMessage = async (e) => {
    try {
      socket.emit("broadcast notification", values.typeName);
      history("/vehicleTypes");
      notifySuccess();
    } catch (error) {
      console.log(error.response);
      if (error.response) {
        notifyError();
      }
    }
  };

  return (
    // Use MUI's Container with the sx prop overriding margins:
    <div className="content-wrappers" style={{ marginTop: '-40px' }}>
    <Container maxWidth="lg" sx={{ ...styles.container, ml: -1, mr: 1 }}>
      <ToastContainer />
      <ContentCard>
        <Header>
          <h2>Broadcast Message</h2>
        </Header>
        <Body>
          <form onSubmit={handleSubmit} autoComplete="off">
            <FormGroup>
              <Label htmlFor="inputName">Message to Drivers</Label>
              <TextArea
                value={values.typeName}
                onChange={handleChange}
                onBlur={handleBlur}
                className={errors.typeName && touched.typeName ? "input-error" : ""}
                name="typeName"
                id="inputName"
                rows="5"
              />
              {errors.typeName && touched.typeName && <Error>{errors.typeName}</Error>}
            </FormGroup>
            <Button disabled={isSubmitting} onClick={submitForm} type="submit">
              Send Broadcast
            </Button>
          </form>
        </Body>
      </ContentCard>
    </Container>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: "white",
    paddingTop: "2rem",
    paddingBottom: "2rem",
    textAlign: "left", // Ensure inline text is left aligned
    minHeight: "100vh",
  },
};

const ContentCard = styled.div`
  background: white;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const Header = styled.div`
  background: #1e40af;
  color: white;
  padding: 1.5rem;
  
  h2 {
    margin: 0;
    font-size: 1.25rem;
    text-align: left;
  }
`;

const Body = styled.div`
  padding: 2rem;
  text-align: left;
`;

const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  color: #334155;
  font-weight: 500;
  text-align: left;
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  font-size: 1rem;
  transition: border-color 0.3s;

  &:focus {
    outline: none;
    border-color: #1e40af;
  }

  &.input-error {
    border-color: #ef4444;
  }
`;

const Error = styled.p`
  color: #ef4444;
  font-size: 0.875rem;
  margin-top: 0.5rem;
  text-align: left;
`;

const Button = styled.button`
  background: #1e40af;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s;
  text-align: left;

  &:hover:not(:disabled) {
    background: #1e3a8a;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export default BroadcastMessage;
